export const ANCHOR_SCREEN_PX = 10;
export const ANCHOR_TOUCH_PX = 24;

export const getScreenSizedAnchorStyle = (isCoarsePointer) => (anchor) => {
  const parentScale = Math.abs(anchor.getParent()?.getAbsoluteScale()?.x || 1) || 1;
  const scale = 1 / parentScale;
  anchor.scaleX(scale);
  anchor.scaleY(scale);
  anchor.hitStrokeWidth(isCoarsePointer ? ANCHOR_TOUCH_PX - ANCHOR_SCREEN_PX : 'auto');
};
